$(document).ready(function(){

    const tournamentsList = $('.tournaments__list');
    let eventsData = [];

    function getEventsData () {
        $.ajax({
            type: "GET",
            url: `/ajax/tournaments`,
            success: function (data) {
                eventsData = data;

                let calendar = new Calendar({
                    id: "#color-calendar",
                    calendarSize: "large",
                    theme: "glass",
                    // primaryColor: "#27a0f3",
                    headerColor: "#ffffff",
                    headerBackgroundColor: "#27a0f3",
                    startWeekday: 1,
                    customMonthValues: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                    customWeekdayValues: ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
                    monthChanged: () => {
                        console.log(111, 'changed month')
                    },
                    dateChanged: (currentDate, events) => {
                        tournamentsList.empty()
                        if (!events.length) {
                            tournamentsList[0].insertAdjacentHTML('beforeend', `
                    <div class="tournaments__no">
                        На выбранную дату ШШ "Этюд" не проводит турниры.
                    </div>
                `)
                        } else {
                            events.map(function (item) {
                                tournamentsList[0].insertAdjacentHTML('beforeend', `
                    <div class="tournaments__item">
                        <div class="tournaments__date">${item.date_from} - ${item.date_to}</div>
                        <p class="tournaments__description">
                            ${item.name}
                        </p>
                        <div class="tournaments__buttons">
                            <a href="/tournaments/${item.link}" class="button button--tournaments">Подробнее о турнире</a>
                            <button class="button button--blue button--tournaments" data-popup-name="popup-tournament" data-tournament-name="${encodeURIComponent(item.name)}">Записаться на турнир</button>
                        </div>
                    </div>
                `)
                            });
                        }
                    },
                    eventsData: eventsData
                });
            }
        });
    }

    if (location.href.indexOf('tournament') >= 0 || window.location.pathname === '/') {
        getEventsData();
    }
});
